<template>
<b-container >
        <h1 >Mitarbeiter Anfrage</h1>
        <b-card no-body v-if="employeeDataRequest != null" footer-tag="footer">
            
            <b-card-body id="nav-scroller" ref="content" style="position:relative; height:500px; overflow-y:scroll;">
            <b-form>
                <b-form-group label-cols="4" label-cols-lg="2" label="Anrede" label-for="cefield1">
                    <b-form-select id = "cefield1" v-model="employeeDataRequest.data.title">
                        <option></option>
                        <option>Herr</option>
                        <option>Frau</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Titel" label-for="cefield2">
                    <b-form-input id="cefield2" v-model="employeeDataRequest.data.prefix"></b-form-input>
                </b-form-group>
           
                <b-form-group label-cols="4" label-cols-lg="2" label="Vorname" label-for="cefield3">
                    <b-form-input id="cefield3" v-model="employeeDataRequest.data.firstName"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Mädchenname" label-for="cefield4">
                    <b-form-input id="cefield4" v-model="employeeDataRequest.data.maidenName"></b-form-input>
                </b-form-group>

                 <b-form-group label-cols="4" label-cols-lg="2" label="Nachname" label-for="cefield5">
                    <b-form-input id="cefield5" v-model="employeeDataRequest.data.lastName"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Titel 2" label-for="cefield6">
                    <b-form-input id="cefield6" v-model="employeeDataRequest.data.postfix"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Geburtsdatum" label-for="cefield7">
                    <b-form-input id="cefield7" v-model="employeeDataRequest.data.dob" type="date"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Religion" label-for="cefield8">
                    <b-form-input id="cefield8" v-model="employeeDataRequest.data.religion"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Gender" label-for="cefield9">
                    <b-form-select id = "cefield9" v-model="employeeDataRequest.data.gender">
                        <option>M</option>
                        <option>F</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="50 % Behinderung" label-for="cefield10">
                    <b-form-checkbox id="cefiedl10" v-model="employeeDataRequest.data.disability">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Führerschein" label-for="cefield11">
                    <b-form-checkbox id="cefiedl11" v-model="employeeDataRequest.data.driverslicense">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Führerschein Ablaufdatum" label-for="cefield12">
                    <b-form-input id="cefield12" v-model="employeeDataRequest.data.dlExpiry" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Erste Hilfe Kurs" label-for="cefield13">
                    <b-form-checkbox id="cefiedl13" v-model="employeeDataRequest.data.firstaidcourse">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Erste Hilfe Kurs Ablaufdatum" label-for="cefield14">
                    <b-form-input id="cefield14" v-model="employeeDataRequest.data.faExpiry" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Email" label-for="cefield15">
                    <b-form-input id ="cefield15" v-model="employeeDataRequest.data.email" type="email"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Heim-Telefon" label-for="cefield16">
                    <b-form-input id = "cefield16" v-model="employeeDataRequest.data.homephone" type="tel"></b-form-input>
                </b-form-group>

                 <b-form-group label-cols="4" label-cols-lg="2" label="Mobil-Telefon" label-for="cefield17">
                    <b-form-input id = "cefield17" v-model="employeeDataRequest.data.mobilephone" type="tel"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Adresse" label-for="cefield18">
                    <b-form-input id="cefield18" v-model="employeeDataRequest.data.address"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="PLZ" label-for="cefield19">
                    <b-form-input id="cefield19" v-model="employeeDataRequest.data.postalCode"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Stadt" label-for="cefield20">
                    <b-form-input id="cefield20" v-model="employeeDataRequest.data.city"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Land" label-for="cefield21">
                    <b-form-select id = "cefield21" v-model.number="employeeDataRequest.data.country">
                         <option v-for="(value, key, index) in countryMap" v-bind:key ="index" v-bind:value="key">
                            {{ value }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="SV - Nummer" label-for="cefield22">
                    <b-form-input id="cefield22" v-model="employeeDataRequest.data.socialsecurity"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="IBAN" label-for="cefield23">
                    <b-form-input id="cefield23" v-model="employeeDataRequest.data.iban"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="BIC" label-for="cefield24">
                    <b-form-input id="cefield24" v-model="employeeDataRequest.data.bic"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Nationalität" label-for="cefield25">
                    <b-form-select id = "cefield25" v-model.number="employeeDataRequest.data.nationality">
                         <option v-for="(value, key, index) in countryMap" v-bind:key ="index" v-bind:value="key">
                            {{ value }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Bürger-Typ" label-for="cefield26">
                    <b-form-select id = "cefield26" v-model.number="employeeDataRequest.data.citizenType">
                        <option v-bind:value="1">EU Bürger</option>
                        <option v-bind:value="2">Nicht-EU Bürger</option>
                        <option v-bind:value="3">Kroatien</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Mitarbeiter seit" label-for="cefield27">
                    <b-form-input id="cefield27" v-model="employeeDataRequest.data.employedSince" type="date"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Vormund Name" label-for="cefield28">
                    <b-form-input id="cefield28" v-model="employeeDataRequest.data.guardianName"></b-form-input>
                </b-form-group>

                <b-form-group   label-cols="4" label-cols-lg="2" label="Vormund Adresse" label-for="cefield29">
                    <b-form-input id="cefield29" v-model="employeeDataRequest.data.guardianAdress"></b-form-input>
                </b-form-group>
                
                <b-form-group id="signature"   label-cols="4" label-cols-lg="2" label="Unterschrift" label-for="cefield30">
                    <b-form-input id="cefield30" v-model="employeeDataRequest.signature"></b-form-input>
                </b-form-group>
            </b-form>
            </b-card-body>
            <div slot="footer">
                <b-row>
                    <b-col>
                        <b-button variant="success" @click="confirmEmployeeDataRequest()">Daten bestätigen</b-button>
                    </b-col>
                    <b-col>
                        <b-button variant="primary" @click="loadEmployeeDataRequest()">Aktualisieren</b-button>
                    </b-col>
                </b-row>
           
                <b-row v-if="error">
                    Fehler beim Aktualisieren der Mitarbeiter Daten.
                </b-row>
            </div>
            
            
        </b-card>
    </b-container>

</template>

<script>

export default {
  name: 'EmployeeDataRequest',
  data () {
    return {
       employeeDataRequest: null,
       countryMap: {
          1: "Österreich",
          2: "Deutschland",
          3: "Italien"
       },
       error: false,
      
    }
  },
  created: function () {
      this.loadEmployeeDataRequest();
  },
  // methods that implement data logic.
  methods: {
    loadEmployeeDataRequest : function() {
      let view = this;
      let url = '/api/public/employeedatarequest';

      url = this.$helpers.appendParam("id", this.$route.params.id, url, '/api/public/employeedatarequest');
      url = this.$helpers.appendParam("token", this.$route.params.token, url, '/api/public/employeedatarequest');
      

      this.axios({
        method: 'get',
        url: url
      }).then(response => {
        let item = response.data;
        item.data.dob = view.$helpers.extractDateString(item.data.dob);
        item.data.dlExpiry = view.$helpers.extractDateString(item.data.dlExpiry);
        item.data.faExpiry = view.$helpers.extractDateString(item.data.faExpiry);
        item.data.employedSince = view.$helpers.extractDateString(item.data.employedSince);

        view.employeeDataRequest = item;
        
      }).catch(function (error) {
         console.log(error);
      })
        
        
    },
    
    confirmEmployeeDataRequest : function() {
        let view = this;
        let url = '/api/public/employeedatarequest';

        url = this.$helpers.appendParam("id", this.$route.params.id, url, '/api/public/employeedatarequest');
        url = this.$helpers.appendParam("token", this.$route.params.token, url, '/api/public/employeedatarequest');
        
        let payload = this.employeeDataRequest;
        payload.updateFields =["data", "signature"];
        for (var property in this.employeeDataRequest) {
            if(!this.$helpers.isBlank(this.employeeDataRequest[property])){
                 payload[property] = this.employeeDataRequest[property];
            } else {
                payload[property] = null;
            }
            
        }
        payload.data.updateFields =[];
        for (var property in this.employeeDataRequest.data) {
            if(!this.$helpers.isBlank(this.employeeDataRequest.data[property])){
                 payload.data[property] = this.employeeDataRequest.data[property];
            } else {
                payload.data[property] = null;
            }
            payload.data.updateFields.push(""+property);  
        }
        payload.data.dob = this.$helpers.convertDateTimeString(this.employeeDataRequest.data.dob);
        payload.data.updateFields.push("dob");
        payload.data.dlExpiry = this.$helpers.convertDateTimeString(this.employeeDataRequest.data.dlExpiry);
        payload.data.updateFields.push("dlExpiry");
        payload.data.faExpiry = this.$helpers.convertDateTimeString(this.employeeDataRequest.data.faExpiry);
        payload.data.updateFields.push("faExpiry");
        payload.data.employedSince = this.$helpers.convertDateTimeString(this.employeeDataRequest.data.employedSince);
        payload.data.updateFields.push("employedSince");
        delete payload.hash;

        this.axios({
            method: 'put',
            url: url,
            data: payload
        }).then(response => {
            view.navigateToHome()
        }).catch(function (error) {
            view.error = true;
        })
        
        
    },
    navigateToHome: function(){
        this.$router.push({ name: 'login' })
    }
  },
  components: {
     
  },
  computed: {
   
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
